/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as SignedOutRouteImport } from './routes/signed-out'
import { Route as UnavailableRouteImport } from './routes/unavailable'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminContactsIndexRouteImport } from './routes/admin.contacts.index'
import { Route as AdminContactsNewRouteImport } from './routes/admin.contacts.new'
import { Route as AdminCustomersIndexRouteImport } from './routes/admin.customers.index'
import { Route as AdminCustomersNewRouteImport } from './routes/admin.customers.new'
import { Route as AdminSettingsIndexRouteImport } from './routes/admin.settings.index'
import { Route as AdminSettingsPeopleRouteImport } from './routes/admin.settings.people'
import { Route as AdminContactsContactIdIndexRouteImport } from './routes/admin.contacts.$contactId.index'
import { Route as AdminContactsContactIdEditRouteImport } from './routes/admin.contacts.$contactId.edit'
import { Route as AdminCustomersCompanyIdIndexRouteImport } from './routes/admin.customers.$companyId.index'
import { Route as AdminCustomersCompanyIdEditRouteImport } from './routes/admin.customers.$companyId.edit'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const SignedOutRoute = SignedOutRouteImport.update({
  id: '/signed-out',
  path: '/signed-out',
  getParentRoute: () => rootRouteImport,
} as any)
const UnavailableRoute = UnavailableRouteImport.update({
  id: '/unavailable',
  path: '/unavailable',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminContactsIndexRoute = AdminContactsIndexRouteImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminContactsNewRoute = AdminContactsNewRouteImport.update({
  id: '/contacts/new',
  path: '/contacts/new',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCustomersIndexRoute = AdminCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCustomersNewRoute = AdminCustomersNewRouteImport.update({
  id: '/customers/new',
  path: '/customers/new',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsIndexRoute = AdminSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsPeopleRoute = AdminSettingsPeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminContactsContactIdIndexRoute =
  AdminContactsContactIdIndexRouteImport.update({
    id: '/contacts/$contactId/',
    path: '/contacts/$contactId/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminContactsContactIdEditRoute =
  AdminContactsContactIdEditRouteImport.update({
    id: '/contacts/$contactId/edit',
    path: '/contacts/$contactId/edit',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCustomersCompanyIdIndexRoute =
  AdminCustomersCompanyIdIndexRouteImport.update({
    id: '/customers/$companyId/',
    path: '/customers/$companyId/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCustomersCompanyIdEditRoute =
  AdminCustomersCompanyIdEditRouteImport.update({
    id: '/customers/$companyId/edit',
    path: '/customers/$companyId/edit',
    getParentRoute: () => AdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/signed-out': typeof SignedOutRoute
  '/unavailable': typeof UnavailableRoute
  '/admin/settings': typeof AdminSettingsRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/admin/contacts/new': typeof AdminContactsNewRoute
  '/admin/customers/new': typeof AdminCustomersNewRoute
  '/admin/settings/people': typeof AdminSettingsPeopleRoute
  '/admin/contacts/': typeof AdminContactsIndexRoute
  '/admin/customers/': typeof AdminCustomersIndexRoute
  '/admin/settings/': typeof AdminSettingsIndexRoute
  '/admin/contacts/$contactId/edit': typeof AdminContactsContactIdEditRoute
  '/admin/customers/$companyId/edit': typeof AdminCustomersCompanyIdEditRoute
  '/admin/contacts/$contactId/': typeof AdminContactsContactIdIndexRoute
  '/admin/customers/$companyId/': typeof AdminCustomersCompanyIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/signed-out': typeof SignedOutRoute
  '/unavailable': typeof UnavailableRoute
  '/admin': typeof AdminIndexRoute
  '/admin/contacts/new': typeof AdminContactsNewRoute
  '/admin/customers/new': typeof AdminCustomersNewRoute
  '/admin/settings/people': typeof AdminSettingsPeopleRoute
  '/admin/contacts': typeof AdminContactsIndexRoute
  '/admin/customers': typeof AdminCustomersIndexRoute
  '/admin/settings': typeof AdminSettingsIndexRoute
  '/admin/contacts/$contactId/edit': typeof AdminContactsContactIdEditRoute
  '/admin/customers/$companyId/edit': typeof AdminCustomersCompanyIdEditRoute
  '/admin/contacts/$contactId': typeof AdminContactsContactIdIndexRoute
  '/admin/customers/$companyId': typeof AdminCustomersCompanyIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/signed-out': typeof SignedOutRoute
  '/unavailable': typeof UnavailableRoute
  '/admin/settings': typeof AdminSettingsRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/admin/contacts/new': typeof AdminContactsNewRoute
  '/admin/customers/new': typeof AdminCustomersNewRoute
  '/admin/settings/people': typeof AdminSettingsPeopleRoute
  '/admin/contacts/': typeof AdminContactsIndexRoute
  '/admin/customers/': typeof AdminCustomersIndexRoute
  '/admin/settings/': typeof AdminSettingsIndexRoute
  '/admin/contacts/$contactId/edit': typeof AdminContactsContactIdEditRoute
  '/admin/customers/$companyId/edit': typeof AdminCustomersCompanyIdEditRoute
  '/admin/contacts/$contactId/': typeof AdminContactsContactIdIndexRoute
  '/admin/customers/$companyId/': typeof AdminCustomersCompanyIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/signed-out'
    | '/unavailable'
    | '/admin/settings'
    | '/admin/'
    | '/admin/contacts/new'
    | '/admin/customers/new'
    | '/admin/settings/people'
    | '/admin/contacts/'
    | '/admin/customers/'
    | '/admin/settings/'
    | '/admin/contacts/$contactId/edit'
    | '/admin/customers/$companyId/edit'
    | '/admin/contacts/$contactId/'
    | '/admin/customers/$companyId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/signed-out'
    | '/unavailable'
    | '/admin'
    | '/admin/contacts/new'
    | '/admin/customers/new'
    | '/admin/settings/people'
    | '/admin/contacts'
    | '/admin/customers'
    | '/admin/settings'
    | '/admin/contacts/$contactId/edit'
    | '/admin/customers/$companyId/edit'
    | '/admin/contacts/$contactId'
    | '/admin/customers/$companyId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/signed-out'
    | '/unavailable'
    | '/admin/settings'
    | '/admin/'
    | '/admin/contacts/new'
    | '/admin/customers/new'
    | '/admin/settings/people'
    | '/admin/contacts/'
    | '/admin/customers/'
    | '/admin/settings/'
    | '/admin/contacts/$contactId/edit'
    | '/admin/customers/$companyId/edit'
    | '/admin/contacts/$contactId/'
    | '/admin/customers/$companyId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  SignedOutRoute: typeof SignedOutRoute
  UnavailableRoute: typeof UnavailableRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signed-out': {
      id: '/signed-out'
      path: '/signed-out'
      fullPath: '/signed-out'
      preLoaderRoute: typeof SignedOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unavailable': {
      id: '/unavailable'
      path: '/unavailable'
      fullPath: '/unavailable'
      preLoaderRoute: typeof UnavailableRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/contacts/': {
      id: '/admin/contacts/'
      path: '/contacts'
      fullPath: '/admin/contacts/'
      preLoaderRoute: typeof AdminContactsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/contacts/new': {
      id: '/admin/contacts/new'
      path: '/contacts/new'
      fullPath: '/admin/contacts/new'
      preLoaderRoute: typeof AdminContactsNewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/customers/': {
      id: '/admin/customers/'
      path: '/customers'
      fullPath: '/admin/customers/'
      preLoaderRoute: typeof AdminCustomersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/customers/new': {
      id: '/admin/customers/new'
      path: '/customers/new'
      fullPath: '/admin/customers/new'
      preLoaderRoute: typeof AdminCustomersNewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings/': {
      id: '/admin/settings/'
      path: '/'
      fullPath: '/admin/settings/'
      preLoaderRoute: typeof AdminSettingsIndexRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/people': {
      id: '/admin/settings/people'
      path: '/people'
      fullPath: '/admin/settings/people'
      preLoaderRoute: typeof AdminSettingsPeopleRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/contacts/$contactId/': {
      id: '/admin/contacts/$contactId/'
      path: '/contacts/$contactId'
      fullPath: '/admin/contacts/$contactId/'
      preLoaderRoute: typeof AdminContactsContactIdIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/contacts/$contactId/edit': {
      id: '/admin/contacts/$contactId/edit'
      path: '/contacts/$contactId/edit'
      fullPath: '/admin/contacts/$contactId/edit'
      preLoaderRoute: typeof AdminContactsContactIdEditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/customers/$companyId/': {
      id: '/admin/customers/$companyId/'
      path: '/customers/$companyId'
      fullPath: '/admin/customers/$companyId/'
      preLoaderRoute: typeof AdminCustomersCompanyIdIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/customers/$companyId/edit': {
      id: '/admin/customers/$companyId/edit'
      path: '/customers/$companyId/edit'
      fullPath: '/admin/customers/$companyId/edit'
      preLoaderRoute: typeof AdminCustomersCompanyIdEditRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminSettingsRouteChildren {
  AdminSettingsPeopleRoute: typeof AdminSettingsPeopleRoute
  AdminSettingsIndexRoute: typeof AdminSettingsIndexRoute
}

const AdminSettingsRouteChildren: AdminSettingsRouteChildren = {
  AdminSettingsPeopleRoute: AdminSettingsPeopleRoute,
  AdminSettingsIndexRoute: AdminSettingsIndexRoute,
}

const AdminSettingsRouteWithChildren = AdminSettingsRoute._addFileChildren(
  AdminSettingsRouteChildren,
)

interface AdminRouteChildren {
  AdminSettingsRoute: typeof AdminSettingsRouteWithChildren
  AdminIndexRoute: typeof AdminIndexRoute
  AdminContactsNewRoute: typeof AdminContactsNewRoute
  AdminCustomersNewRoute: typeof AdminCustomersNewRoute
  AdminContactsIndexRoute: typeof AdminContactsIndexRoute
  AdminCustomersIndexRoute: typeof AdminCustomersIndexRoute
  AdminContactsContactIdEditRoute: typeof AdminContactsContactIdEditRoute
  AdminCustomersCompanyIdEditRoute: typeof AdminCustomersCompanyIdEditRoute
  AdminContactsContactIdIndexRoute: typeof AdminContactsContactIdIndexRoute
  AdminCustomersCompanyIdIndexRoute: typeof AdminCustomersCompanyIdIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminSettingsRoute: AdminSettingsRouteWithChildren,
  AdminIndexRoute: AdminIndexRoute,
  AdminContactsNewRoute: AdminContactsNewRoute,
  AdminCustomersNewRoute: AdminCustomersNewRoute,
  AdminContactsIndexRoute: AdminContactsIndexRoute,
  AdminCustomersIndexRoute: AdminCustomersIndexRoute,
  AdminContactsContactIdEditRoute: AdminContactsContactIdEditRoute,
  AdminCustomersCompanyIdEditRoute: AdminCustomersCompanyIdEditRoute,
  AdminContactsContactIdIndexRoute: AdminContactsContactIdIndexRoute,
  AdminCustomersCompanyIdIndexRoute: AdminCustomersCompanyIdIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  SignedOutRoute: SignedOutRoute,
  UnavailableRoute: UnavailableRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
